import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {B2B_DROPDOWN} from "../preSales/b2bAlliance/type";
import {
  CONTRACT_CATEGORY_SERVICES,
  CONTRACT_REVENUE,
  LINE_ITEMS_APPROVAL_LIST, LINE_ITEMS_APPROVAL_REJECTION, LINE_ITEMS_BY_INVOICE_ID,
  LINE_ITEMS_UPDATE,
  VALET_CONTRACT_INVOICE,
  GET_SERVICES,
  REVENUE_NATURE,
  MANAGEMENT_FEE,
  CAPEX_CONTRACT_INVOICE
} from "./type";

export const postSalesCorporateLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    products,
    paymentTermsDesc,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    isSEZ,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipFileUpload,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    categoryInventory,
    nonGstFile,
    tags,
    payment,
    increament,
    installationData,
    installation_charge,
    paymentDueDays,
    clientData,
    solution_type,
    milestone,
    InvoiceModuleData,
    rel_docs
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: `${slotsNoFourWheeler}`,
    two_wheeler_slots: `${slotsNoTwoWheeler}`,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: `${agreementContractPeriodFrom}`,
        contract_to_date: `${agreementContractPeriodTo}`,
        contract_period: `${agreementContractLength}`,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gstType: `${gstType}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        start_time: `${fromTime}`,
        end_time: `${toTime}`,
        other_rule: `${anyOther}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: `${paymentTermsDesc}`,
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        product_id: `${products}`,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_term_desciption: `${paymentTermsDesc}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        expected_live_date:`${expectedLive}`,
        rel_docs: `${rel_docs}`
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    
    // gates: [...gateDetails],
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],
    installation: installationData,
    hardware: [...categoryInventory],
    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData
  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
  }
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostCorporate
  );
  // console.log(res); return false;
  if (res.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};
export const postSalesApartmentLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipFileUpload,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    // toTime,
    // fromTime,
    pickDate,
    gateDetails,
    scope_of_civil_work,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    clientData,
    solution_type,
    milestone,
    rel_docs,
    optFor,
    invoice_gen,
    opt_amount,
    fastag_integrable,
    InvoiceModuleData,
    pocData,
    salesType,
    channelPartner,
    channelPartnerValue,
    revenue_nature,
    revenue_type,
    invoice_type,
    variable_services,
    fixed_services
  } = val;
  const data = {
    salesType:`${salesType}`,
    channelPartner:`${channelPartner}`,
    channelPartnerValue:`${channelPartnerValue}`,
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: slotsNoFourWheeler,
    two_wheeler_slots: slotsNoTwoWheeler,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
        optFor: optFor,
        opt_amount: opt_amount,
        invoice_gen: invoice_gen,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gstType: `${gstType}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        /* start_time: `${fromTime}`,
        end_time: `${toTime}`, */
        other_rule: `${anyOther}`,
      },
    ],
    // gates: [...gateDetails],
    hardware: [...categoryInventory],
    commercial: [
      {
        commercial_type_id: commercialType,
        description: `${paymentTermsDesc}`,
        client_share: clientShare,
        company_share: companyShare,
        cost_per_slot: costPerSlot,
        no_of_mg_slots: MGSlots,
        take: takeEtaxes,
        take_percentage: takePerct,
        installation_amount: installationAmount,
        subscription_amount: subAmt,
        payment_terms_id: paymentTerms,
        product_id: products,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        fastag_integrable: `${fastag_integrable}`,
        rel_docs: `${rel_docs}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: billGeoStateId,
        geo_city_id: billGeoCityId,
        geo_pin_code: billPinId,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: shipGeoStateId,
        geo_city_id: shipGeoCityId,
        geo_pin_code: shipPinId,
      },
    ],
    installation: installationData,
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],

    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData,
    pocData: pocData,
  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
    data.variable_services = variable_services
    data.fixed_services = fixed_services
  }
      // console.log(data); return false;

  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostApartment
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};
export const postSalesSupplyLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    marketingReq,
    materialPhotos,
    materialVideos,
   overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    slotsRevenue4Car,
    slotsRevenue2Bike,
    parkCommission,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    clientData,
    solution_type,
    milestone,
    rel_docs,
    agreementDocument,
    marketingSignageCount,
    marketingSignageType,
    approachVideo,
    slots2MgBike,
    slots4MgCar,
    commission,
    InvoiceModuleData,
    pocData,
    revenue_nature,
    revenue_type,
    invoice_type,
    variable_services,
    fixed_services,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    expected_live_date: `${expectedLive}`,
    // four_wheeler_slots_mg: `${slots2MgBike}`,
    // two_wheeler_slots_mg: `${slots4MgCar}`,
    four_wheeler_slots_revenue: `${slotsRevenue4Car}`,
    two_wheeler_slots_revenue: `${slotsRevenue2Bike}`,
    cost_per_slot: `${costPerSlot}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    // is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gstType: `${gstType}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: '',
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        product_id: products,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots !== '' ? revenueSlots : 0}`,
        revenue_share: `${revenueShare !== '' ? revenueShare : 0}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,	
        solution_type: `${solution_type}`,	
        rel_docs: `${rel_docs}`,
        commission: `${commission}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    installation: installationData,	
    tags: [...tags],	
    // increament: [...increament],	
    payment:[...payment],	
    client: clientData,	
    milestone: milestone,
    // gates: [...gateDetails],
    hardware: [...categoryInventory],
    InvoiceModuleData:InvoiceModuleData,
    pocData:pocData
  };
  if(leadStatus === 9){
    data.gates = [...gateDetails];
    data.variable_services = variable_services
    data.fixed_services = fixed_services
  }
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.createPostSupply
  );
  if (res?.data?.status === true) {
    return true;
  }
  return false;
};

export const postInvoiceNumber=(val) => async (dispatch) => {
  // postInvoiceNumber
  const res = await callWebService(
    callTypes.post,
    val,
    Config.postSales.postInvoiceNumber
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const postSalesEditApartmentLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    // toTime,
    // fromTime,
    pickDate,
    gateDetails,
    scope_of_civil_work,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    solution_type,
    InvoiceModuleData,
    milestone,
    rel_docs,
    optFor,
    invoice_gen,
    opt_amount,
    fastag_integrable,
    pocData,
    salesType,
    channelPartner,
    channelPartnerValue,
    shipFileUpload,
    // clientData
    revenue_nature,
    revenue_type,
    invoice_type,
    variable_services,
    fixed_services,
    builderType
  } = val;
  const data = {
    salesType:`${salesType}`,
    channelPartner:`${channelPartner}`,
    channelPartnerValue:`${channelPartnerValue}`,
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: slotsNoFourWheeler,
    two_wheeler_slots: slotsNoTwoWheeler,
    expected_live_date: `${expectedLive}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
        optFor: optFor,
        opt_amount: opt_amount,
        invoice_gen: invoice_gen,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gstType: `${gstType}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        /* start_time: `${fromTime}`,
        end_time: `${toTime}`, */
        other_rule: `${anyOther}`,
      },
    ],
    gates: [...gateDetails],
    hardware: [...categoryInventory],
    commercial: [
      {
        commercial_type_id: commercialType,
        description: `${paymentTermsDesc}`,
        client_share: clientShare,
        company_share: companyShare,
        cost_per_slot: costPerSlot,
        no_of_mg_slots: MGSlots,
        take: takeEtaxes,
        take_percentage: takePerct,
        installation_amount: installationAmount,
        subscription_amount: subAmt,
        payment_terms_id: paymentTerms,
        product_id: products,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        fastag_integrable: `${fastag_integrable}`,
        rel_docs: `${rel_docs}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
        builder_type:`${builderType}`,
      },
    ],
    // bill_to: [
    //   {
    //     address_line_1: `${billAddressLine1}`,
    //     address_line_2: `${billAddressLine2}`,
    //     geo_state_id: billGeoStateId,
    //     geo_city_id: billGeoCityId,
    //     geo_pin_code: billPinId,
    //   },
    // ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: shipGeoStateId,
        geo_city_id: shipGeoCityId,
        geo_pin_code: shipPinId,
      },
    ],
    installation: installationData,
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],
    InvoiceModuleData:InvoiceModuleData,
    milestone: milestone,
    pocData: pocData,
    variable_services: variable_services,
    fixed_services: fixed_services
    // client: clientData

  };
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.editApartmentContract
  );
  if (res?.data?.response.status === true) {
    // const { data } = res;
    return true;
  }
};

export const postSalesEditCorporateLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    products,
    paymentTermsDesc,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    isSEZ,
    marketingReq,
    materialPhotos,
    materialVideos,
    overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    categoryInventory,
    nonGstFile,
    tags,
    payment,
    increament,
    installationData,
    installation_charge,
    paymentDueDays,
    clientData,
    solution_type,
    milestone,
    InvoiceModuleData,
    rel_docs,
    pocData,
    revenue_nature,
    revenue_type,
    invoice_type,
    variable_services,
    fixed_services,
    shipFileUpload,
  } = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    four_wheeler_slots: `${slotsNoFourWheeler}`,
    two_wheeler_slots: `${slotsNoTwoWheeler}`,
    expected_live_date: `${expectedLive}`,
    marketing_requirement: `${marketingReq}`,
    no_of_tags: `${TagsNoPost}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    site_photo: materialPhotos,
    site_video: materialVideos,
    contract_type: `${detailsProvide}`,
    file_upload: (shipFileUpload!=null)?`${shipFileUpload.replace(/^"+|"+$/g, '')}`:`${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: `${agreementContractPeriodFrom}`,
        contract_to_date: `${agreementContractPeriodTo}`,
        contract_period: `${agreementContractLength}`,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gstType: `${gstType}`,
        gst_number: `${gstNumber}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    parking_rules: [
      {
        overnight_parking_allowed: `${overnight}`,
        two_wheeler_allowed_with_car: `${twowheelers}`,
        start_time: `${fromTime}`,
        end_time: `${toTime}`,
        other_rule: `${anyOther}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: `${paymentTermsDesc}`,
        client_share: `${clientShare}`,
        company_share: `${companyShare}`,
        cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        take: `${takeEtaxes}`,
        take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        product_id: `${products}`,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        revenue_share_slot: `${revenueSlots}`,
        revenue_share: `${revenueShare}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_term_desciption: `${paymentTermsDesc}`,
        payment_due_days: `${paymentDueDays}`,
        solution_type: `${solution_type}`,
        expected_live_date:`${expectedLive}`,
        rel_docs: `${rel_docs}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
      },
    ],
    /* bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ], */
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    
    gates: [...gateDetails],
    tags: [...tags],
    increament: [...increament],
    payment:[...payment],
    installation: installationData,
    hardware: [...categoryInventory],
    client: clientData,
    milestone: milestone,
    InvoiceModuleData:InvoiceModuleData,
    pocData:pocData,
    variable_services: variable_services,
    fixed_services: fixed_services
  };
  // console.log(data); return false;
  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.editCorpContract
  );
  // console.log(res); return false;
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const postSalesEditSupplyLead = (val) => async (dispatch) => {
  const {
    leadId,
    leadStatus,
    comm_id,
    isNewContract,
    LockIn,
    MGPerSlot,
    MGSlots,
    TagsNoPost,
    agreementContractLength,
    agreementSigningDate,
    clientShare,
    commercialType,
    companyShare,
    costPerSlot,
    detailsProvide,
    installationAmount,
    pODate,
    pONumber,
    paymentMode,
    latePayCharge,
    paymentTerms,
    paymentTermsDesc,
    products,
    revenueShare,
    revenueSlots,
    securityDeposit,
    slotsNoFourWheeler,
    slotsNoTwoWheeler,
    subAmt,
    takeEtaxes,
    takePerct,
    totalAmount,
    totalContract,
    yearlyInclin,
    anyOther,
    billAddressLine1,
    billAddressLine2,
    billGeoCityId,
    billGeoStateId,
    billPinId,
    expectedLive,
    gstFile,
    gstNumber,
    gstRegis,
    gstType,
    marketingReq,
    materialPhotos,
    materialVideos,
   overnight,
    po_woNumber,
    portForwarding,
    remarks,
    shipAddressLine1,
    shipAddressLine2,
    shipGeoCityId,
    shipGeoStateId,
    shipPinId,
    twowheelers,
    po_woCopy,
    agreementContractUpload,
    agreementContractPeriodFrom,
    agreementContractPeriodTo,
    pOUpload,
    toTime,
    fromTime,
    pickDate,
    scope_of_civil_work,
    gateDetails,
    slotsRevenue4Car,
    slotsRevenue2Bike,
    parkCommission,
    categoryInventory,
    nonGstFile,
    paymentDueDays,
    installationData,
    tags,
    payment,
    increament,
    clientData,
    solution_type,
    milestone,
    rel_docs,
    agreementDocument,
    marketingSignageCount,
    marketingSignageType,
    approachVideo,
    slots2MgBike,
    slots4MgCar,
    commission,
    pocData,
    revenue_nature,
    revenue_type,
    invoice_type,
    variable_services,
    fixed_services,
    shipFileUpload,
} = val;
  const data = {
    lead_id: `${leadId}`,
    leadStatus: `${leadStatus}`,
    comm_id:`${comm_id}`,
    // isNewContract:`${isNewContract}`,
    security_deposit: `${securityDeposit}`,
    expected_live_date: `${expectedLive}`,
    // four_wheeler_slots_mg: `${slots2MgBike}`,
    // two_wheeler_slots_mg: `${slots4MgCar}`,
    four_wheeler_slots_revenue: `${slotsRevenue4Car}`,
    two_wheeler_slots_revenue: `${slotsRevenue2Bike}`,
    cost_per_slot: `${costPerSlot}`,
    port_forwarding: `${portForwarding}`,
    scope_of_civil_work: `${scope_of_civil_work}`,
    remarks: `${remarks}`,
    contract_copy: `${po_woCopy}`,
    contract_number: `${po_woNumber}`,
    // is_sez: `${isSEZ}`,
    working_timing: `${pickDate}`,
    contract_type: `${detailsProvide}`,
    file_upload: `${shipFileUpload}`,
    contract_details: [
      {
        contract_document: `${agreementContractUpload}`,
        contract_sign_date: `${agreementSigningDate}`,
        contract_from_date: agreementContractPeriodFrom,
        contract_to_date: agreementContractPeriodTo,
        contract_period: agreementContractLength,
      },
    ],
    po_details: [
      {
        po_document: `${pOUpload}`,
        po_number: `${pONumber}`,
        po_date: `${pODate}`,
      },
    ],
    gst_details: [
      {
        gst_registered: `${gstRegis}`,
        gst_number: `${gstNumber}`,
        gstType: `${gstType}`,
        gst_document: `${gstFile}`,
        upload_non_gst_disclosure_form: `${nonGstFile}`,
      },
    ],
    commercial: [
      {
        commercial_type_id: `${commercialType}`,
        description: '',
        // client_share: `${clientShare}`,
        // company_share: `${companyShare}`,
        // cost_per_slot: `${costPerSlot}`,
        no_of_mg_slots: `${MGSlots}`,
        // take: `${takeEtaxes}`,
        // take_percentage: `${takePerct}`,
        installation_amount: `${installationAmount}`,
        subscription_amount: `${subAmt}`,
        payment_terms_id: `${paymentTerms}`,
        product_id: products,
        payment_mode: `${paymentMode}`,
        latePayCharge: `${latePayCharge}`,
        total_contract_length: `${totalContract}`,
        contract_lockin_period: `${LockIn}`,
        yearly_inclination: `${yearlyInclin}`,
        total_amount: `${totalAmount}`,
        // revenue_share_slot: `${revenueSlots !== '' ? revenueSlots : 0}`,
        // revenue_share: `${revenueShare !== '' ? revenueShare : 0}`,
        mg_cost_per_slot: `${MGPerSlot}`,
        payment_due_days: `${paymentDueDays}`,	
        solution_type: `${solution_type}`,	
        rel_docs: `${rel_docs}`,
        commission: `${commission}`,
        revenue_nature: `${revenue_nature}`,
        revenue_type: `${revenue_type}`,
        invoice_type: `${invoice_type}`,
      },
    ],
    bill_to: [
      {
        address_line_1: `${billAddressLine1}`,
        address_line_2: `${billAddressLine2}`,
        geo_state_id: `${billGeoStateId}`,
        geo_city_id: `${billGeoCityId}`,
        geo_pin_code: `${billPinId}`,
      },
    ],
    ship_to: [
      {
        address_line_1: `${shipAddressLine1}`,
        address_line_2: `${shipAddressLine2}`,
        geo_state_id: `${shipGeoStateId}`,
        geo_city_id: `${shipGeoCityId}`,
        geo_pin_code: `${shipPinId}`,
      },
    ],
    installation: installationData,	
    tags: [...tags],	
    // increament: [...increament],	
    payment:[...payment],	
    client: clientData,	
    milestone: milestone,
    gates: [...gateDetails],
    hardware: [...categoryInventory],
    pocData:pocData,
    variable_services: variable_services,
    fixed_services: fixed_services
  };

  const res = await callWebService(
    callTypes.post,
    data,
    Config.postSales.editSupplyContract
  );
  if (res?.data?.status === 0 && res?.data?.data?.status === true) {
    return true;
  }
  if (res?.data?.response?.status === true) {
    return true;
  }
  return false;
};

export const getContractRevenue = () => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.contractRevenueType}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: CONTRACT_REVENUE, payload: data });
    return data;
  } else {
    return null;
  }
};

export const getRevenueNature = (leadId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.getRevenueNature}?lead_id=${leadId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: REVENUE_NATURE, payload: data });
    return data;
  } else {
    return null;
  }
};

export const checkManagementFeeApplicable = (leadId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.checkManagementFeeApplicable}?lead_id=${leadId}`
  );
  if (res) {
    const outer = res.data;
    const payload = outer?.response ?? outer;
    const data = payload?.data ?? outer?.data;
    dispatch({ type: MANAGEMENT_FEE, payload: data });
    return data;
  } else {
    return null;
  }
};

export const getContractService = (id) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.contractCategoryService}?id=${id}`
  );
  const payload = res?.data?.data ?? res?.data?.response?.data;
  if (payload) {
    dispatch({ type: CONTRACT_CATEGORY_SERVICES, payload });
    return payload;
  } else {
    return null;
  }
};

const SERVICE_INVOICE_PAGE_LIMIT = 15;
const SALES_COORDINATOR_ROLE_ID = 4;
const FINANCE_HEAD_ROLE_ID = 13;
const FINANCE_DIRECTOR_ROLE_ID = 49;

const textValue = (value) => (typeof value === "string" ? value.trim() : "");

const loggedInUserEmail = (getState) => {
  try {
    const details = JSON.parse(localStorage.getItem("loginDetails") || "null");
    const storedEmail = textValue(details?.email);
    if (storedEmail) return storedEmail;
  } catch (error) {
    // loginDetails is optional; the profile email is the fallback.
  }
  return textValue(getState?.()?.loginReducer?.userProfile?.email);
};

const scopeServiceInvoiceListByEmail = (filters, invoiceId, getState) => {
  if (presentFilterValue(invoiceId)) return;
  const roleId = Number(localStorage.getItem("fusion-role"));
  if (
    roleId === SALES_COORDINATOR_ROLE_ID ||
    roleId === FINANCE_HEAD_ROLE_ID ||
    roleId === FINANCE_DIRECTOR_ROLE_ID
  ) return;
  const email = loggedInUserEmail(getState);
  if (!email) return;
  filters.email_id_list = [email];
};

const presentFilterValue = (value) =>
  value !== undefined &&
  value !== null &&
  value !== "" &&
  value !== "Invalid date";

const numericOrRaw = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "" && Number.isFinite(Number(value))) {
    return Number(value);
  }
  return value;
};

const buildServiceInvoiceQuery = (filter, invoiceId) => {
  const filters = { invoice_type: 1 };
  const searchFilters = {};

  if (presentFilterValue(invoiceId)) {
    searchFilters.invoice_id = numericOrRaw(invoiceId);
  }

  if (filter && typeof filter === "object" && !Array.isArray(filter)) {
    if (presentFilterValue(filter.invoice_no)) {
      searchFilters.invoice_number = filter.invoice_no;
    }
    if (presentFilterValue(filter.ti_number)) {
      searchFilters.ti_number = filter.ti_number;
    }
    if (presentFilterValue(filter.site_number)) {
      searchFilters.site_number = filter.site_number;
    }
    if (presentFilterValue(filter.client_name)) {
      searchFilters.client_name = filter.client_name;
    }
    if (presentFilterValue(filter.installment_status)) {
      filters.installment_status = filter.installment_status;
    }
    if (presentFilterValue(filter.billing_type)) {
      filters.billing_type = numericOrRaw(filter.billing_type);
    }
    if (presentFilterValue(filter.from_pi_date) && presentFilterValue(filter.to_pi_date)) {
      filters.invoice_date = {
        from: filter.from_pi_date,
        to: filter.to_pi_date,
      };
    }
  }

  return { filters, searchFilters };
};

const toLegacyInvoiceList = (data, page, limit) => {
  const results = Array.isArray(data?.results) ? data.results : [];
  const perPage = Number(data?.limit) || limit;
  const currentPage = Number(data?.page) || page;
  const total = Number(data?.count) || 0;
  const from = results.length > 0 ? (currentPage - 1) * perPage + 1 : 0;

  return {
    resultSets: results,
    total,
    per_page: perPage,
    current_page: String(currentPage),
    from,
    to: results.length > 0 ? from + results.length - 1 : 0,
    last_page: perPage > 0 ? Math.ceil(total / perPage) : 0,
  };
};

export const getValetContractInvoice = (page = 1, invoiceType = 1, filter = [{}], invoiceId = "", status = "") => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.b2bInvoiceList}?page=${page}&installment_type=${invoiceType}&invoice_id=${invoiceId}&invoice_no=${filter?.invoice_no ?? ""}&ti_number=${filter?.ti_number ?? ""}&installment_status=${filter?.installment_status ?? ""}&billing_type=${filter?.billing_type ?? ""}&site_number=${filter?.site_number ?? ""}&client_name=${filter?.client_name ?? ""}&from_pi_date=${filter?.from_pi_date ?? ""}&to_pi_date=${filter?.to_pi_date ?? ""}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: VALET_CONTRACT_INVOICE, payload: data });
    return data;
  }
  return null;
};

export const getServiceInvoiceList = (page = 1, _invoiceType = 1, filter = [{}], invoiceId = "") => async (dispatch, getState) => {
  const limit = SERVICE_INVOICE_PAGE_LIMIT;
  const requestedPage = Number(page) || 1;
  const { filters, searchFilters } = buildServiceInvoiceQuery(filter, invoiceId);
  scopeServiceInvoiceListByEmail(filters, invoiceId, getState);
  const requestBody = {
    page: requestedPage,
    limit,
    filters,
  };
  if (Object.keys(searchFilters).length > 0) {
    requestBody.search_filters = searchFilters;
  }
  const res = await callWebService(
      callTypes.post,
      requestBody,
      Config.postSales.variableValetContractInvoice
  );

  const body = res?.data;
  const isSuccess =
    body &&
    String(body.message || "").toUpperCase() === "SUCCESS" &&
    body.data &&
    Array.isArray(body.data.results);

  if (!isSuccess) {
    return null;
  }

  const payload = toLegacyInvoiceList(body.data, requestedPage, limit);
  dispatch({ type: VALET_CONTRACT_INVOICE, payload });
  return payload;
};

export const getServicesOnDemand = () => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSalesNew.getOnDemandServices}`
  );
  if (res?.data?.status === 0) {
    const data = res.data.data ?? res.data.response?.data ?? [];
    dispatch({ type: GET_SERVICES, payload: data });
    return data;
  }
  if (res?.data?.response?.status === true) {
    const { data } = res.data.response;
    dispatch({ type: GET_SERVICES, payload: data });
    return data;
  }
  return null;
};

export const lineItemsUpdate = (list) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,list,
      Config.postSales.valetServiceLineItemsUpdate
  );
  if (res) {
    const { data } = res;
    dispatch({ type: LINE_ITEMS_UPDATE, payload: data });
    return data;
  } else {
    return null;
  }
};

export const getValetItemLineApprovalList = (page= 1, filter = [{}]) => async (dispatch) => {
  console.log(filter)
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.valetServiceLineItemsApprovalList}?page${page}&invoice_no=${filter?.invoice_no ?? ""}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: LINE_ITEMS_APPROVAL_LIST, payload: data });
    return data;
  } else {
    return null;
  }
};

export const getValetItemLineInvoiceId = (invoiceId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.valetServiceLineItemsByInvoiceId}?invoice_id=${invoiceId}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: LINE_ITEMS_BY_INVOICE_ID, payload: data });
    return data;
  } else {
    return null;
  }
};

export const convertServiceInvoice = (invoiceId, action, remark) => async () => {
  const body = {
    invoice_id: Number(invoiceId),
    action,
  };
  if (typeof remark === "string" && remark.trim() !== "") {
    body.remark = remark.trim();
  }
  const res = await callWebService(
    callTypes.post,
    body,
    Config.postSales.convertServiceInvoice
  );
  return res?.data ?? null;
};

export const lineItemsApprovalRejection = (list) => async (dispatch) => {
  const res = await callWebService(
      callTypes.post,list,
      Config.postSales.valetServiceLineItemsApprovalRejection
  );
  if (res) {
    const { data } = res;
    dispatch({ type: LINE_ITEMS_APPROVAL_REJECTION, payload: data });
    return data;
  } else {
    return null;
  }
};

export const getCapexContractInvoice = (page = 1, invoiceType = 1, filter = [{}] ,invoiceId='', status='') => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.postSales.capexContractInvoice}?page=${page}&installment_type=${invoiceType}&invoice_id=${invoiceId}&invoice_no=${filter?.invoice_no ?? ''}&ti_number=${filter?.ti_number ?? ''}&installment_status=${filter?.installment_status ?? ''}&billing_type=${filter?.billing_type ?? ''}&site_number=${filter?.site_number ?? ''}&client_name=${filter?.client_name ?? ''}&from_pi_date=${filter?.from_pi_date ?? ''}&to_pi_date=${filter?.to_pi_date ?? ''}&role=${filter?.role ?? ''}`
  );
  if (res) {
    const { data } = res.data.response;
    dispatch({ type: CAPEX_CONTRACT_INVOICE, payload: data });
    return data;
  } else {
    return null;
  }
};

export const updateCapexStatus = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.postSales.updateContractInvoice}`
  );
  if(res) {
    const { data } = res;
    return data.response.status;
  }
};